<template>
    <div v-if="imgEl" :class="`fetch-loading ${imgEl}`" :style="loadingStyle" id="fectchLoading">
        <div class="main">
          <img :src="require(`./imgs/${imgEl}.png`)" alt="">
          <svg-icon v-if="imgEl === 'icon2'" icon-class="orderSong" />
        </div>
        <img
          v-if="imgEl === 'icon2'"
          src="https://qncweb-back1.ktvsky.com/20231214/other/df5add3c3b3cf6d8853d9cb55d3648a3.png"
          class="theme-light-icon"
        >
    </div>
</template>
<script>
import svgIcon from '@/components/common/svg_icon/svg';

export default {
  props: ['imgEl', 'loadingStyle'],
  components: {
    svgIcon,
  },
};
</script>
<style lang="scss" scoped>
.svg-icon {
    width: 80px;
    height: 82px;
    position: absolute;
    right: -20px;
    top: 0;
}
.fetch-loading {
    top: 130px;
}
.fetch-loading.icon2 {
  z-index: 1000;
}
.icon1, .icon2, .icon4 {
    width: 280px;
    height: 82px;
    position: fixed;
    top: initial;
    bottom: 159px;
}
.icon4 {
    z-index: 1001;
}
.theme-light-icon {
  display: none;
  width: 280px;
  position: fixed;
  bottom: 48px;
  left: 50%;
  margin-left: -140px;
}
html[data-theme="light"] {
  .main {
    display: none;
  }
  .theme-light-icon {
    display: block;
  }
}
</style>
